import { InjectionToken } from '@angular/core';
import { IConstraint } from '@se/se.platform.base';
import type { ICustomPage, IDataset, IPlaceholders, IServerDataSource, Json, JsonObject } from '@se/cp.common';
import { Observable } from 'rxjs';

export interface ICustomPageLayoutData {
    constraints: IConstraint[];
    dataSources: IServerDataSource;
    dataset: IDataset;
    idModelTypes: string[];
    layout: ICustomPage;
    placeholders: IPlaceholders;
}

export interface ICustomPageMasterData extends ICustomPageLayoutData {
    idCustomPage: string;
    model: JsonObject;
}

export interface ICustomPageMasterDataResolver {
    getCustomPageRoot(): string;

    getModelTypes(): string[];

    getLayout(idCustomPage: string): Observable<ICustomPageLayoutData>;

    /**
     * I Valori sono opzionali perché possono essere letti dal resolver in qualche altro modo, es. dal router.
     */
    getMasterData(idExaminations?: string[], idCustomPageRoot?: string): Observable<ICustomPageMasterData>;

    getData(): Observable<Json>;
}

export const CustomPageMasterDataResolver = new InjectionToken('CustomPageMasterDataResolver');
